<div class="ltms-wordcloud-container">
    <div class="ltms-wordcloud-header">
        <div class="ltms-description w-75"> {{tabDescription}}</div>
        <div class="litmus-feed-list-paging" *ngIf="!isAccountLevelFeeds">
            <button [disabled]="!pagingButtons.isFirst" (click)="paginateFeedList('first')">
                <img src="assets/images/chevron-double-left.svg" />
            </button>
            <button [disabled]="!pagingButtons.isPrevious" (click)="paginateFeedList('previous')">
                <img src="assets/images/chevron-left.svg" />
            </button>
            <span [class.disabled]="pagingDetails.total <= 0"> {{pagingDetails.start}} - {{pagingDetails.end}} of
                {{pagingDetails.total}} </span>
            <button [disabled]="!pagingButtons.isNext" (click)="paginateFeedList('next')">
                <img src="assets/images/chevron-right.svg" />
            </button>
            <button [disabled]="!pagingButtons.isLast" (click)="paginateFeedList('last')">
                <img src="assets/images/chevron-double-right.svg" />
            </button>
        </div>
    </div>
    <div class="ltms-wordcloud-body">
        <div id="ltms-wordcloud-chart" class="ltms-wordcloud-chart">
            <div id="litmus-word-cloud" *ngIf="!loadingWordCloud && !wordcloudNotAvailable" class="litmus-word-cloud"></div>
            <app-ltms-loader *ngIf="loadingWordCloud"></app-ltms-loader>
            <app-ltms-error *ngIf="!loadingWordCloud && wordcloudNotAvailable" [code]="'404'"></app-ltms-error>
        </div>
        <div class="wordcloud-feed-list" [class.loading]="!isFeedListLoaded">
            <app-ltms-loader *ngIf="!isFeedListLoaded"></app-ltms-loader>
            <app-ltms-data-table-v2 *ngIf="isFeedListLoaded" [configs]="tableConfig" [columns]="columns" [data]="feeds" [errorCode]="'404'"
                (onSelect)="showFeedDetails($event)" (onSort)="sortFeedList($event)" (onRowSelect)="showFeedDetails($event)"></app-ltms-data-table-v2> 
        </div>
    </div>
</div>
<app-feed-detail-panel (onPageChange)="onPageChange($event)"></app-feed-detail-panel>